import React from 'react';

import './CandlestickTileSettings.scss';
import WidgetSettingsShowDataForEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsShowDataForEditor';
import WidgetSettingsBucketSizeEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsBucketSizeEditor';
import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';
import { CandlestickTileConfigState } from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';

import { useCandlestickTileConfigSlice } from 'widgets/candlestickTile/store/config/configslice';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const CandlestickTileSettingsText = `Candlestick Capsule Settings`;

export interface CandlestickTileSettingsProps {
    config?: CandlestickTileConfigState;
    onChange?: (nextDelta: Partial<CandlestickTileConfigState>) => void;
}

export default function CandlestickTileSettings(
    props: CandlestickTileSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useCandlestickTileConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="CandlestickTileSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsShowDataForEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />

                <WidgetSettingsBucketSizeEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
